export const USER_INPUT_PREVIEW_PREAMBLE_REQUEST = 'USER_INPUT_PREVIEW_PREAMBLE_REQUEST';
export const USER_INPUT_PREVIEW_PREAMBLE_SUCCESS = 'USER_INPUT_PREVIEW_PREAMBLE_SUCCESS';
export const USER_INPUT_PREVIEW_PREAMBLE_FAIL = 'USER_INPUT_PREVIEW_PREAMBLE_FAIL';